export class Validation {

  static isAlphaNumeric(str: string): boolean {
    let code: number;
    let index: number;
    const len: number = str.length;

    for (index = 0; index < len; index++) {
      code = str.charCodeAt(index);
      if (!(code > 47 && code < 58) && // numeric (0-9)
          !(code > 64 && code < 91) && // upper alpha (A-Z)
          !(code > 96 && code < 123)) { // lower alpha (a-z)
        return false;
      }
    }
    return true;
  };

}
